import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/css/fonts.css";
import "@/css/main.css";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(VueAxios, axios);
app.use(ElementPlus);

app.mount("#app");
